import { revokeOwnOrganisationAccess } from '../../../../../organisations/src/core/api';

import { queryClient } from '../../../../core/queryClient';
import { createMutation } from '../../../../utils/mutations';
import { workspacesListingQueryKey } from '../../queries/workspacesListingQuery';

interface RemoveOrganisationAccessInput {
  organisationId: string;
  workspaceId: string;
}

type RemoveOrganisationAccessResult = Awaited<ReturnType<typeof revokeOwnOrganisationAccess>>;

export const removeOrganisationAccessMutation = () =>
  createMutation<RemoveOrganisationAccessInput, RemoveOrganisationAccessResult>({
    mutationFn: ({ organisationId, workspaceId }) => revokeOwnOrganisationAccess(workspaceId, organisationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: workspacesListingQueryKey() });
    }
  });
